import { useState } from 'react';
import { directusAPI } from '../../../api';

/**
 * Publish-to-website, archive and delete actions of the article editor
 * (with their confirmation modal state).
 */
export function useArticleLifecycleActions({ id, token, navigate }) {
  // Delete article modal
  const [showDeleteArticleModal, setShowDeleteArticleModal] = useState(false);
  const [isDeletingArticle, setIsDeletingArticle] = useState(false);

  // Publish WordPress modal
  const [showPublishWordPressModal, setShowPublishWordPressModal] = useState(false);
  const [isPublishing, setIsPublishing] = useState(false);

  // Archive article modal
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const [isArchiving, setIsArchiving] = useState(false);

  const handlePublishWebsite = () => {
    setShowPublishWordPressModal(true);
  };

  const confirmPublishWebsite = async () => {
    setIsPublishing(true);
    try {
      const response = await directusAPI.post(`flows/trigger/e288d7ff-9439-4e78-9d7a-19eb041b96e6`, {
        article_id: id
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      console.log('✅ Article published to website:', response.data);
      window.alert('Article published to website successfully.');
      setShowPublishWordPressModal(false);
    } catch (error) {
      console.error('❌ Error publishing article to website:', error);
      window.alert('Failed to publish article to website. Please try again.');
    } finally {
      setIsPublishing(false);
    }
  };

  // Handle delete article
  const handleDeleteArticle = () => {
    setShowDeleteArticleModal(true);
  };

  const handleArchiveArticle = () => {
    setShowArchiveModal(true);
  };

  const confirmArchiveArticle = async () => {
    setIsArchiving(true);
    try {
      await directusAPI.patch(`/items/articles/${id}`, {
        status: 'archived'
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      console.log('✅ Article archived successfully');
      setShowArchiveModal(false);
      navigate('/articles');
    } catch (error) {
      console.error('❌ Error archiving article:', error);
      window.alert('Failed to archive article. Please try again.');
      setIsArchiving(false);
    }
  };

  const confirmDeleteArticle = async () => {
    setIsDeletingArticle(true);
    try {
      await directusAPI.delete(`/items/articles/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      console.log('✅ Article deleted successfully');

      // Navigate back to articles list
      navigate('/articles');
    } catch (error) {
      console.error('❌ Error deleting article:', error);
      window.alert('Failed to delete article. Please try again.');
    } finally {
      setIsDeletingArticle(false);
      setShowDeleteArticleModal(false);
    }
  };

  return {
    showDeleteArticleModal,
    setShowDeleteArticleModal,
    isDeletingArticle,
    showPublishWordPressModal,
    setShowPublishWordPressModal,
    isPublishing,
    showArchiveModal,
    setShowArchiveModal,
    isArchiving,
    handlePublishWebsite,
    confirmPublishWebsite,
    handleDeleteArticle,
    handleArchiveArticle,
    confirmArchiveArticle,
    confirmDeleteArticle,
  };
}
